import React, { useRef } from "react";
import '../less/table.less';
import clearBR from "utils/clearBR";

export default function template() {
    const { data, page, isMobile } = this.props,
      columns = data.columns.map((item, index) => {
        const columnText = isMobile ? clearBR(this.l10n(item.column)) : this.l10n(item.column);
        const valueBG = index === 0 ? <div className="value-background" style={{ height: this.state.height }}></div> : '';
        let value;
        if (Array.isArray(item.value)) {
          if (isMobile) {
            value = item.value.length === 1 ? (
              (<div className="value-wrapper">
                <div className="value" dangerouslySetInnerHTML={{ __html: this.l10n(item.value[0])}}></div>
                {valueBG}
              </div>)
            ) : item.value.length === 4 && page === "payments" ? (
              <div className="value-wrapper">
                <div className="value"
                  dangerouslySetInnerHTML={{
                    __html: `${this.l10n(item.value[0])} ${this.l10n('GREEN_CARD_TABLE_ROW_1_3')} ${this.l10n(item.value[1])} ${this.l10n('GREEN_CARD_TABLE_ROW_1_3')} ${this.l10n(item.value[2])} ${this.l10n('GREEN_CARD_TABLE_ROW_1_3')} ${this.l10n(item.value[3])}`,
                  }}
                ></div>
                {valueBG}
              </div>
            ) : (
              (<div className="value-wrapper">
                <div className="value" dangerouslySetInnerHTML={{ __html: `${this.l10n(item.value[0])} ${this.l10n('GREEN_CARD_TABLE_ROW_1_3')} ${this.l10n(item.value[1])}`}}></div>
                {valueBG}
              </div>)
            );            
          } else {
            value = item.value.map((item, i) => {
              const text = this.l10n(item);
              return (
                <div key={i} className="value-wrapper">
                  <div className="value" dangerouslySetInnerHTML={{ __html: text}}></div>
                  {valueBG}
                </div>
              )
            })
          }
        } else {
          value = (<div className="value-wrapper">
                    <div className="value" dangerouslySetInnerHTML={{ __html: isMobile ? clearBR(this.l10n(item.value)) : this.l10n(item.value)}}></div>
                    {valueBG}
                  </div>);
        }
        return (
          <div className="column-wrapper" key={index}>
            <div className="column" dangerouslySetInnerHTML={{ __html: columnText}}></div>
            {value}
          </div>
        )
      });

    return (
      <section ref={this.myRef} className={`table-module ${page}`}>
        {columns}
      </section>
    );
}
